import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';

import { openImageLightBox } from '../../actions/ImageLightBox';
import { photosShow } from '../../helpers/photosShow';
import { toWebp } from '../../helpers/imageHelper';

import s from './ListGridCoverPhoto.css';

import mediumNoImage from './medium_no_image.png';
import largeNoImage from './large_no_image.jpeg';
import { fileuploadDir } from '../../config';

class ListGridCoverPhoto extends React.Component {
    static propTypes = {
        coverPhoto: PropTypes.number,
        listPhotos: PropTypes.array,
        className: PropTypes.string,
        bgImage: PropTypes.bool
    };

    static defaultProps = {
        bgImage: false
    }

    constructor(props) {
        super(props);
        this.state = {
            photo: null
        };
    }

    UNSAFE_componentWillMount() {
        const { coverPhoto, listPhotos } = this.props;
        let activePhoto;
        if (listPhotos != undefined && listPhotos.length > 0) {
            activePhoto = listPhotos[0].name;
            if (coverPhoto != undefined && coverPhoto != null) {
                listPhotos.map((item) => {
                    if (item.id === coverPhoto) {
                        activePhoto = item.name;
                    }
                })
            }
            this.setState({ photo: activePhoto });
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { coverPhoto, listPhotos } = nextProps;
        let activePhoto;
        if (listPhotos != undefined && listPhotos.length > 0) {
            activePhoto = listPhotos[0].name;
            if (coverPhoto != undefined && coverPhoto != null) {
                listPhotos.map((item) => {
                    if (item.id === coverPhoto) {
                        activePhoto = item.name;
                    }
                })
            }
            this.setState({ photo: activePhoto });
        }
    }

    openSliderClick = (index) => {
        const { openImageLightBox } = this.props;
        let root = document.getElementsByTagName('html')[0];
        root.classList.add('scrollHidden');
        openImageLightBox(index);
    }

    render() {
        const { className, photoType, bgImage, listPhotos } = this.props;
        const { photo } = this.state;

        let img0, img1, img2, img3;
        if (listPhotos != undefined && listPhotos.length > 0) {
            img0 = listPhotos[0]?.src;
            img1 = listPhotos[1]?.src;
            img2 = listPhotos[2]?.src;
            img3 = listPhotos[3]?.src;
        }

        let path = '', source, imagePath;
        imagePath = photosShow(fileuploadDir);

        if (photo != null) {
            source = toWebp(photo);
            if (photoType != undefined) {
                path = imagePath + photoType + '_';
            }
        } else {
            if (photoType != undefined) {
                if (photoType === "xx_large") {
                    source = largeNoImage;
                } else if (photoType === "x_medium") {
                    source = mediumNoImage;
                }
            } else {
                source = mediumNoImage
            }
        }

        if (bgImage) {
            const photoCount = listPhotos?.length || 0;

            // Single image layout
            if (photoCount === 1) {
                return (
                    <div className={s.singleImageContainer}>
                        <div
                            className={cx(className, s.bgbanner, s.singleImageFull)}
                            style={{ backgroundImage: `url(${img0})` }}
                            onClick={() => this.openSliderClick(0)}
                        >
                            {this.props.children}
                        </div>
                    </div>
                );
            }

            // Two images layout
            if (photoCount === 2) {
                return (
                    <div className={s.displayGrid}>
                        <div
                            className={cx(className, s.bgbanner, s.firstImage)}
                            style={{ backgroundImage: `url(${img0})` }}
                            onClick={() => this.openSliderClick(0)}
                        >
                            {this.props.children}
                        </div>
                        <div
                            className={cx(className, s.bgbanner, s.secondImageOnly)}
                            style={{ backgroundImage: `url(${img1})` }}
                            onClick={() => this.openSliderClick(1)}
                        />
                    </div>
                );
            }

            // Three images layout
            if (photoCount === 3) {
                return (
                    <div className={s.displayGrid}>
                        <div
                            className={cx(className, s.bgbanner, s.firstImage)}
                            style={{ backgroundImage: `url(${img0})` }}
                            onClick={() => this.openSliderClick(0)}
                        >
                            {this.props.children}
                        </div>
                        <div>
                            <div
                                className={cx(className, s.bgbanner, s.secondImage)}
                                style={{ backgroundImage: `url(${img1})` }}
                                onClick={() => this.openSliderClick(1)}
                            />
                            <div
                                className={cx(className, s.bgbanner, s.thirdImageOnly)}
                                style={{ backgroundImage: `url(${img2})` }}
                                onClick={() => this.openSliderClick(2)}
                            />
                        </div>
                    </div>
                );
            }

            // Four or more images layout
            return (
                <div className={s.displayGrid}>
                    <div
                        className={cx(className, s.bgbanner, s.firstImage, 'listGridPhotoFirstImageRTL')}
                        style={{ backgroundImage: `url(${img0})` }}
                        onClick={() => this.openSliderClick(0)}
                    >
                        {this.props.children}
                    </div>
                    <div>
                        <div
                            className={cx(className, s.bgbanner, s.secondImage, 'listGridPhotoSecondImageRTL')}
                            style={{ backgroundImage: `url(${img1})` }}
                            onClick={() => this.openSliderClick(1)}
                        />
                        <div className={s.displayGrid}>
                            <div
                                className={cx(className, s.bgbanner, s.thiredImage, 'listGridPhotoThridImageRTL')}
                                style={{ backgroundImage: `url(${img3})` }}
                                onClick={() => this.openSliderClick(3)}
                            />
                            <div
                                className={cx(className, s.bgbanner, s.fouthImage, 'listGridPhotoForthImageRTL')}
                                style={{ backgroundImage: `url(${img2})` }}
                                onClick={() => this.openSliderClick(2)}
                            />
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <img src={path + source} className={className} />
            );
        }
    }
}

const mapState = (state) => ({});

const mapDispatch = {
    openImageLightBox
};

export default withStyles(s)(connect(mapState, mapDispatch)(ListGridCoverPhoto));